// message type = { message: string, id: string, type: 'error'|'success'|'warning'|'info'}

const PLACEHOLDER = '|___|';

export const CONTRACT_MESSAGE = {};

export const WALLET_MESSAGE = {
  noWallet: {
    message: 'Install MetaMask to connect to Blockpad.',
    id: 'no-wallet',
    type: 'error',
  },
  wrongNetwork: {
    message: `Your wallet is currently connected to a different network. Please change it to the ${PLACEHOLDER} to continue.`,
    id: 'wrong-network',
    type: 'error',
  },
};

export const LOGIN_MESSAGE = {
  invalidSignature: {
    message: 'Please sign the message in your wallet to continue.',
    id: 'invalid-signature',
    type: 'error',
  },
};

const Messages = {
  LOGIN_MESSAGE,
  WALLET_MESSAGE,
  PLACEHOLDER,
};

export default Messages;
